import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { useAluno } from "@/hooks/alunos";
import { format } from "date-fns";
import { FaPen, FaTrash } from "react-icons/fa";
import { Modal } from "@/components/Common";

import ModalEditExperiencia from "./ModalEditExperiencia";
import ModalAddExperiencia from "./ModalAddExperiencia";
import ModalDeleteExperiencia from "./ModalDeleteExperiencia";

import {
  CircleButton,
  SmallCircleButton,
  Container,
  List,
  ListItem
} from "./styles";

export default function ExperienciasProfissionais() {
  const { aluno } = useAluno();
  const [dataToUpdate, setDataToUpdate] = useState({});
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);

  function updateExperiencia(experiencia) {
    setDataToUpdate(experiencia);
    setModalEditOpen(true);
  }

  function handleDelete(id) {
    setIdToDelete(id);
    setModalDeleteOpen(true);
  }

  function renderLista() {
    return (
      <List>
        <>
          {aluno.experiencias_profissionais.map(e => {
            const dataInicio = format(new Date(e.data_inicio), "MM/yyyy");
            const dataTermino = e.data_termino
              ? format(new Date(e.data_termino), "MM/yyyy")
              : null;

            return (
              <ListItem key={e.id}>
                <h2>{e.empresa_nome}</h2>
                <p className="cargo">{e.cargo}</p>
                <div className="datas">
                  <div>
                    <span>Início</span> {dataInicio}
                  </div>
                  {dataTermino && (
                    <div>
                      <span>Término</span> {dataTermino}
                    </div>
                  )}
                </div>
                {e.atividades && (
                  <>
                    <h4>Descrição</h4>
                    <p className="descricao">{e.atividades}</p>
                  </>
                )}
                <div className="actions">
                  <SmallCircleButton onClick={() => updateExperiencia(e)}>
                    <FaPen size={10} />
                  </SmallCircleButton>
                  <SmallCircleButton danger onClick={() => handleDelete(e.id)}>
                    <FaTrash size={10} />
                  </SmallCircleButton>
                </div>
              </ListItem>
            );
          })}
          <Modal
            open={modalDeleteOpen}
            onClose={() => setModalDeleteOpen(false)}
          >
            <ModalDeleteExperiencia
              id={idToDelete}
              onClose={() => setModalDeleteOpen(false)}
            />
          </Modal>
        </>
      </List>
    );
  }

  return (
    <Container>
      <div className="titulo">
        <h2>Experiências profissionais: </h2>
        <CircleButton onClick={() => setModalAddOpen(true)}>
          <FiPlus />
        </CircleButton>
      </div>
      <div className="contente">{renderLista()}</div>
      <Modal open={modalEditOpen} onClose={() => setModalEditOpen(false)}>
        <ModalEditExperiencia
          data={dataToUpdate}
          onClose={() => setModalEditOpen(false)}
        />
      </Modal>
      <Modal open={modalAddOpen} onClose={() => setModalAddOpen(false)}>
        <ModalAddExperiencia onClose={() => setModalAddOpen(false)} />
      </Modal>
    </Container>
  );
}
